module.exports = __webpack_public_path__ + "img/img_53.beb351af.png";